<template>
<div class="chapter">
<div class="inner_page">
<a id="pxiv"></a>
<h1 class="fronttitle ">Abbreviations of Book Titles</h1>
<table>
<tbody>
<tr>
<td><p class="table">GRB</p></td>
<td><p class="table"><em>The Great Railway Bazaar</em></p></td>
</tr>
<tr>
<td><p class="table">OPE</p></td>
<td><p class="table"><em>The Old Patagonian Express</em></p></td>
</tr>
<tr>
<td><p class="table">KBS</p></td>
<td><p class="table"><em>The Kingdom by the Sea</em></p></td>
</tr>
<tr>
<td><p class="table">SWS</p></td>
<td><p class="table"><em>Sunrise with Seamonsters</em></p></td>
</tr>
<tr>
<td><p class="table">RIR</p></td>
<td><p class="table"><em>Riding the Iron Rooster</em></p></td>
</tr>
<tr>
<td><p class="table">TEE</p></td>
<td><p class="table"><em>To the Ends of the Earth</em></p></td>
</tr>
<tr>
<td><p class="table">HIO</p></td>
<td><p class="table"><em>The Happy Isles of Oceania</em></p></td>
</tr>
<tr>
<td><p class="table">POH</p></td>
<td><p class="table"><em>The Pillars of Hercules</em></p></td>
</tr>
<tr>
<td><p class="table">FAF</p></td>
<td><p class="table"><em>Fresh Air Fiend</em></p></td>
</tr>
<tr>
<td><p class="table">DSS</p></td>
<td><p class="table"><em>Dark Star Safari</em></p></td>
</tr>
<tr>
<td><p class="table">GTES</p></td>
<td><p class="table"><em>Ghost Train to the Eastern Star</em></p></td>
</tr>
<tr>
<td><p class="table">WE</p></td>
<td><p class="table"><em>World’s End</em></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front04.vue?b70fe1b6